<ng-container>
  <div class="availability-edit-header">
    <h1 class="availability-edit-title">
      {{ ("planningMatrix" | i18n) || "Planungsmatrix" | titlecase }}
    </h1>
    <div class="row">
      <div class="col col-md-6">
        <mat-form-field>
          <mat-label>{{ ("date" | i18n) || "Datum" | titlecase }} </mat-label>
          <input
            matInput
            [value]="selectedDate ? (selectedDate | date) : ''"
            readonly
            data-cy="date-picker-input"
            (click)="datePicker.open()" />
          <input
            matInput
            name="datePicker"
            (dateChange)="selectDate($event)"
            (click)="datePicker.open()"
            (keydown)="(false)"
            [matDatepicker]="datePicker"
            [min]="today"
            hidden />
          <mat-datepicker-toggle
            matSuffix
            [for]="datePicker"></mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col col-md-6">
        <app-certificate-select
          [useQueryParam]="'certificates'"></app-certificate-select>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-6">
        <app-demand-reason-select
          [useQueryParam]="'demandReason'"></app-demand-reason-select>
      </div>
    </div>
  </div>
  <ng-container *ngIf="(jobsLoading$ | async) !== false; else contentLoaded">
    <div
      class="loading-container d-flex align-items-center justify-content-center"
      data-cy="planning-matrix-loading-spinner">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #contentLoaded>
    <ng-container *ngIf="(jobs$ | async)?.length; else noOpenJobs">
      <div class="planning-matrix-table-wrapper">
        <div class="side-scroll-table planning-matrix-custom-table">
          <div class="table-cell sticky-header-cell-left">
            <div
              class="table-col table-user-col"
              data-cy="user-table-col">
              <div class="planning-matrix-user-col-spacer"></div>
              <div class="customer-table-user-spacer-row"></div>
              <ng-container *ngFor="let userRow of availableUsers$ | async">
                <div
                  class="table-cell main-label-cell sticky-main-cell-left"
                  [attr.data-cy]="'user-row-' + userRow.user._id">
                  <div
                    class="name"
                    [class.name-shortened]="
                  userRow.user.customerInformation?.[loggedInUser?.customerId || ''] &&
                  userRow.user.customerInformation?.[loggedInUser?.customerId || '']?.poolerType"
                    (click)="
                      userRow.detailsCollapsed = !userRow.detailsCollapsed
                    ">
                    <div
                      [title]="
                        userRow.user.firstName + ' ' + userRow.user.lastName
                      ">
                      {{ userRow.user.firstName }} {{ userRow.user.lastName }}
                    </div>
                    <div
                      *ngIf="userRow.customerOfUser"
                      [title]="userRow.customerOfUser.displayName"
                      class="source-customer"
                      [attr.data-cy]="
                        'source-customer-' + userRow.customerOfUser.id
                      ">
                      {{ "via " + userRow.customerOfUser.displayName }}
                    </div>
                  </div>
                  <div
                    class="custom-chip small-pill poolertype-pill"
                    *ngIf="
            userRow.user.customerInformation?.[loggedInUser?.customerId || ''] &&
            userRow.user.customerInformation?.[loggedInUser?.customerId || '']?.poolerType
        ">
                    {{userRow.user.customerInformation?.[loggedInUser?.customerId
                    || '']?.poolerType?.displayName | uppercase}}
                  </div>
                  <div
                    *ngIf="userRow.availabilityNote"
                    class="availability-note"
                    [matTooltip]="userRow.availabilityNote">
                    <mat-icon
                      class="size-20 text-icon-grey ml-6"
                      svgIcon="note"></mat-icon>
                  </div>
                  <div
                    *ngIf="userRow.hasBeenSelected"
                    class="user-booked">
                    <mat-icon svgIcon="star"></mat-icon>
                  </div>
                </div>
                <div
                  *ngIf="!userRow.detailsCollapsed"
                  class="table-cell user-details-cell sticky-main-cell-left">
                  <div>
                    <user-list-item-details
                      class="user-details mt-1"
                      [user]="userRow.user"></user-list-item-details>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="planning-matrix-organisations-cell table-cell">
            <div
              *ngFor="let organisationRow of organisationRows$ | async"
              class="table-col">
              <div
                class="planning-matrix-organisations-row table-row"
                [attr.data-cy]="'organisation-col-' + organisationRow.id">
                <div class="table-organisation-header-cell table-cell">
                  <div>{{ organisationRow.name }}</div>
                </div>
                <div class="table-cell">
                  <div
                    *ngFor="let departmentRow of organisationRow.departments"
                    class="table-department-header-col table-row"
                    [attr.data-cy]="'department-col-' + departmentRow.id">
                    <div class="table-cell">
                      <div class="table-col">
                        <div class="table-department-header-cell table-cell">
                          <div>{{ departmentRow.name }}</div>
                        </div>
                        <ng-container
                          *ngFor="let user of availableUsers$ | async">
                          <div
                            class="table-department-border-cell table-cell"></div>

                          <div
                            *ngIf="!user.detailsCollapsed"
                            class="table-cell user-details-cell hidden-cell hidden-cell-short">
                            <div>
                              <user-list-item-details
                                class="user-details mt-1"
                                [user]="user.user"></user-list-item-details>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                    <div class="table-cell">
                      <div
                        *ngFor="let jobRow of departmentRow.jobs"
                        class="table-col"
                        [attr.data-cy]="'job-col-' + jobRow.id">
                        <div class="table-job-header-cell table-cell">
                          <div class="table-job-status-bar-wrapper">
                            <div
                              *ngFor="let status of jobRow.status"
                              class="table-job-status-bar"
                              [class.available]="
                                status.inviteeStatus ===
                                inviteeStatusEnum.AVAILABLE
                              "
                              [class.unavailable]="
                                status.inviteeStatus ===
                                inviteeStatusEnum.UNAVAILABLE
                              "
                              [class.booked]="
                                status.inviteeStatus ===
                                inviteeStatusEnum.BOOKED
                              "></div>
                          </div>
                          <div class="table-job-header-cell-content">
                            <div
                              *ngFor="let shift of jobRow.shifts"
                              class="job-shift"
                              data-cy="shift-time">
                              <div class="job-shift-tag">
                                {{
                                  shift.label
                                    ? shift.label
                                    : ("shifts." + shift.shift
                                      | i18n
                                      | titlecase)
                                }}
                              </div>
                              <div class="job-shift-time">
                                {{ shift.from | time }} - {{ shift.to | time }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <ng-container
                          *ngFor="let user of availableUsers$ | async">
                          <div
                            *ngIf="
                              jobRow.usersById.get(
                                user.user._id
                              ) as userAvailability
                            "
                            class="table-cell action-cell"
                            [attr.data-cy]="
                              'availability-cell-' +
                              user.user._id +
                              '-' +
                              jobRow.id
                            "
                            (click)="
                              selectAvailability(jobRow, user.restWarningUser)
                            "
                            [class.action-cell__available]="
                              userAvailability.status ===
                              inviteeStatusEnum.AVAILABLE
                            "
                            [class.action-cell__working]="
                              userAvailability.status ===
                              inviteeStatusEnum.WORKING
                            "
                            [class.action-cell__booked]="
                              userAvailability.status ===
                              inviteeStatusEnum.BOOKED
                            ">
                            <div
                              *ngIf="
                                userAvailability.status ===
                                  inviteeStatusEnum.BOOKED ||
                                userAvailability.status ===
                                  inviteeStatusEnum.AVAILABLE
                              "
                              class="center-icon">
                              <span>
                                {{
                                  ("shiftLetters." + jobRow.shifts[0].shift
                                    | i18n) || jobRow.shifts[0].shift
                                }}
                              </span>
                            </div>
                            <div
                              *ngIf="
                                (userAvailability.status ===
                                  inviteeStatusEnum.AVAILABLE ||
                                  userAvailability.status ===
                                    inviteeStatusEnum.BOOKED) &&
                                userAvailability.restWarning?.restWarning
                              "
                              class="corner-icon"
                              data-cy="rest-warning">
                              <mat-icon
                                svgIcon="bed"
                                [matTooltip]="
                                  userAvailability.restWarning!.restWarning!
                                "></mat-icon>
                            </div>
                          </div>
                          <div
                            *ngIf="!user.detailsCollapsed"
                            class="table-cell user-details-cell hidden-cell">
                            <div>
                              <user-list-item-details
                                class="user-details mt-1"
                                [user]="user.user"></user-list-item-details>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noOpenJobs>
      {{ ("noOpenJobs" | i18n) || "Keine offenen Dienste" }}
    </ng-template>
  </ng-template>
</ng-container>
<div class="floating-actions-bar">
  <ng-container *ngIf="selectedAvailabilities$ | async as selectionSummary">
    <button
      *ngIf="!selectedAvailabilitiesCount"
      class="primary-pill-button icon-left big-fab"
      disabled
      type="button">
      {{ ("book" | i18n) || "Buchen" | titlecase }}
    </button>
    <button
      *ngIf="selectedAvailabilitiesCount"
      (click)="resetSelectedAvailabilities()"
      class="secondary-pill-button icon-left big-fab"
      type="button"
      data-cy="planning-matrix-reset-button">
      <mat-icon svgIcon="undo"></mat-icon>
      {{ ("reset" | i18n) || "Zurücksetzen" | titlecase }}
    </button>
    <button
      *ngIf="selectedAvailabilitiesCount"
      (click)="submitSelectedAvailabilities(selectionSummary)"
      class="primary-pill-button icon-left big-fab"
      type="button"
      data-cy="planning-matrix-book-button">
      {{ selectedAvailabilitiesCount }}
      {{ ("book" | i18n) || "Buchen" | titlecase }}
    </button>
  </ng-container>
</div>
